import { useRef, useEffect } from "react";
import { sources, subSources } from "../constants/source-data";

interface UseSourceFocusProps {
  selectedSource: string;
  selectedSubSource: string;
  allTextInputs: boolean;
}

export const useSourceFocus = ({
  selectedSource,
  selectedSubSource,
  allTextInputs,
}: UseSourceFocusProps) => {
  const textInputRef = useRef<HTMLInputElement>(null);

  // 하위 소스 선택 시 텍스트 입력 필드에 포커스 및 스크롤
  useEffect(() => {
    if (selectedSubSource && textInputRef.current) {
      // 하위 소스가 선택된 경우에만 포커스 및 스크롤
      setTimeout(() => {
        textInputRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        textInputRef.current?.focus();
      }, 100);
    }
  }, [selectedSubSource]);

  // 모든 하위 소스가 텍스트 입력인 경우 (맘카페, 네이버블로그) 포커스 및 스크롤
  useEffect(() => {
    if (selectedSource && textInputRef.current) {
      const sourceId = sources.find((s) => s.label === selectedSource)?.id;
      if (sourceId && subSources[sourceId]) {
        // 모든 하위 소스가 텍스트 입력인지 확인
        const allTextInputs = subSources[sourceId].every(
          (subSource) => subSource.type === "text"
        );

        if (allTextInputs) {
          // 모든 하위 소스가 텍스트 입력이면 포커스 및 스크롤
          setTimeout(() => {
            textInputRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
            textInputRef.current?.focus();
          }, 100);
        }
      }
    }
  }, [selectedSource]);

  return {
    textInputRef,
  };
};
